var $window, $body, $header;
var arrLeonardGTMTrackingFormPath = [
  "/book-a-service/",
  "/contact-us/",
  "/get-a-demo/",
  "/get-a-quote/",
  "/order-spare-parts/",
  "/custom-your-truck/",

  "/en-US/book-a-service/",
  "/en-US/contact-us/",
  "/en-US/get-a-demo/",
  "/en-US/get-a-quote/",
  "/en-US/order-spare-parts/",
  "/en-US/custom-your-truck/",

  "/fr/obtenir-soumission/",
  "/fr/obtenir-demo/",
  "/fr/nous-contacter/",
  "/fr/demande-service/",
  "/fr/demande-pieces/",
  "/fr/personnaliser-camion/",
];

$(function() { initialise(); });
$(window).on("load", loaded);

function initialise() {
  $window = $(window);
  $body = $("body");
  $header = $("header");

  // Lazy init function handler based on Wordpress template name
  if($body.data("init-function") && typeof window[$body.data("init-function")] === "function") {
    window[$body.data("init-function")]();
  }
  jQuery(document).bind('gform_post_render', function(){
    form_fields_init();
  })

  // Sameheights
  sameHeight($(".products-menu .products-menu-hydro, .products-menu .products-menu-sewer, .products-menu .products-menu-wetdry, .products-menu .products-menu-sanitary"), 9999, 1024, "outerHeight");
  sameHeight($(".newsletter-left, .newsletter-right"), 9999, 840, "outerHeight");
  sameHeight($("footer .footer-first-section > div"), 9999, 0, "outerHeight");

  $(".scoll-to").on("click", scrollToElement);

  header_init();
  newsletter_init();
  form_init();
  form_fields_init();
  leonard_gtm_tracking_init();
  form_equipment_cookie_init();

  // Flexible content
  flexiblecontent_init();
}

// Called only when the page is completly loaded
//
function loaded() {
  if ($('.pardot-iframe').length > 0 && $('body').hasClass('page-template-template-resources-center'))
  {
    $('.custom-form').addClass('documentation')
    var downloadDocLink =  $('.content-list a')
    downloadDocLink.click(function(event){
    event.preventDefault();
    })
    downloadDocLink.bind('click', { param: 'open'}, downloadModal);
  }
  $(window).trigger("resize");
}

// ---------------------------------------
// ---------------------------------------
// Helpers
// ---------------------------------------
// ---------------------------------------

function leonard_gtm_tracking_init() {
  // Track CTA pointing to a «Leads Form»
  // -------
  var arrLeonardGTMTrackingCTA = [];
  for(var i=0; i<arrLeonardGTMTrackingFormPath.length; i++){
    arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
  }

  // Custom CSS rules here
  // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

  $(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

  // Track «Leads form» submit button click
  // -------
  if(arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
    $("form button, form input[type=submit]").addClass("gtm-form-submited");
  }


  // Custom CTA tracking here
  // --------

  // #1 - Download brochure links
  $(".introduction-box a.button[href*='.pdf']").addClass("gtm-cta-1");

  // #2 - Links view gallery
  // -- Already added in the HTML

  // #3 - CTA to industries
  $(".title-aside-blocks-small-listing a[href*='/industries/']").addClass("gtm-cta-3");

  // #4 - CTA to dealer locations
  $("a.button[href*='/en-US/dealer-locations/']").addClass("gtm-cta-4");

  // #5 - CTA to dealer locations
  $("a.button[href*='/en-US/become-a-dealer/']").addClass("gtm-cta-5");

  // Lightbox
  $('a.media, a[data-fancybox]').addClass("gtm-lightbox");
}


// Check if the body has a class(es)
//
// @return Boolean
function is_page(body_classes) {
  return $body.hasClass(body_classes);
}


// Convert an object to base64 string
//
// @return String
function json_to_base64(json) {
  var json_string = JSON.stringify(json);
  return btoa(json_string);
}


// Converte base64 string to an object
//
// @return Object
function base64_to_json(base64) {
  var json_string = atob(base64);
  return JSON.parse(json_string);
}


// Return Query string value
//
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


// Basic sprinft method working only with %s
//
// @return String
function sprintf(format, etc) {
  var arg = arguments,
      i = 1;
  return format.replace(/%((%)|s)/g, function (m) { return m[2] || arg[i++] })
}


// Define pardot language
//
// @return String
function pardot_language() {
  switch($("html").attr("lang")) {
      case "fr-FR":
      case "fr-CA":
          return "Français";
          break;

      case "en-CA":
      case "en-US":
      default:
        return "Anglais"
  }
}

// Set cookie
//
function setCookie(cookie_name, value, expiration_days) {
  var expiration_date = new Date();
  expiration_date.setDate(expiration_date.getDate() + expiration_days);

  var cookie_value = escape(value) + ((expiration_days == null) ? "" : "; expires=" + expiration_date.toUTCString())+"; path=/";
  document.cookie = cookie_name + "=" + cookie_value;
}

// Read cookies
//
function getCookie(cookie_name) {
  var cookie_value = document.cookie;
  var cookie_start = cookie_value.indexOf(" " + cookie_name + "=");

  if (cookie_start == -1) cookie_start = cookie_value.indexOf(cookie_name + "=");

  if (cookie_start == -1) {
    cookie_value = null;
  }else{
    cookie_start = cookie_value.indexOf("=", cookie_start) + 1;
    var c_end = cookie_value.indexOf(";", cookie_start);

    if (c_end == -1) c_end = cookie_value.length;

    cookie_value = unescape(cookie_value.substring(cookie_start,c_end));
  }

  return cookie_value;
}

// Scroll to an element
//
function scrollToElement(e) {
  e.preventDefault();
  var $target = $($(e.currentTarget).attr("href"));

  scrollToTarget($target, $(e.currentTarget));
}

// Scroll to a target
//
function scrollToTarget($target, $current) {
  if(is_page("page-template-template-form-focus")) {
    var headerHeight = ($(".gf_page_steps").outerHeight() + 15);
  }else{
    var headerHeight = $header.outerHeight();

    if($current && $current.is(".secondary-navigation a")) {
      headerHeight += 15;
    }
  }

  $("html, body").animate({
    scrollTop: ($target.offset().top - headerHeight),
  }, 500);
}


// Init same-height for a batch of element
//
// @return Void
function sameHeight($objects, startAt, endAt, heightType, callback) {
  startAt = typeof startAt == "undefined" ? 99999 : startAt;
  endAt = typeof endAt == "undefined" ? 0 : endAt;
  heightType = typeof heightType == "undefined" ? "height" : heightType;

  $window.on("resize", {cachedObjects: $objects, startAt: startAt, endAt: endAt, heightType: heightType, callback: callback}, function(e) {
    var $cachedObjects = e.data.cachedObjects;
    var startAt = e.data.startAt;
    var endAt = e.data.endAt;
    var heightType = e.data.heightType;

    if($window.width() <= startAt && $window.width() > endAt) {
      sameHeightSet($cachedObjects, heightType);
      var data_callback = "enable";
    }else{
      $cachedObjects.css({minHeight: 0});
      var data_callback = "disabled";
    }

    // Callback for extra works
    if(typeof e.data.callback != "undefined") {
      e.data.callback(data_callback);
    }
  }).trigger("resize");
}

// Set same-height for a batch of cached elements
//
// @return Void
function sameHeightSet($cachedObjects, heightType) {
  var max = -1;
  var h = 0;

  $cachedObjects.css({minHeight: 0});
  $cachedObjects.each(function() {
    h = heightType == "outerHeight" ? $(this).outerHeight() : $(this).height();
    max = h > max ? h : max;
  });

  $cachedObjects.css({minHeight: max});
}

// Init same-width for a batch of element
//
// @return Void
function sameWidth($objects, startAt, endAt, widthType, callback) {
  startAt = typeof startAt == "undefined" ? 99999 : startAt;
  endAt = typeof endAt == "undefined" ? 0 : endAt;
  widthType = typeof widthType == "undefined" ? "width" : widthType;

  $window.on("resize", {cachedObjects: $objects, startAt: startAt, endAt: endAt, widthType: widthType, callback: callback}, function(e) {
    var $cachedObjects = e.data.cachedObjects;
    var startAt = e.data.startAt;
    var endAt = e.data.endAt;
    var widthType = e.data.widthType;

    if($window.width() <= startAt && $window.width() >= endAt) {
      sameWidthSet($cachedObjects, widthType);
      var data_callback = "enable";
    }else{
      $cachedObjects.css({minWidth: 0});
      var data_callback = "disabled";
    }

    // Callback for extra works
    if(typeof e.data.callback != "undefined") {
      e.data.callback(data_callback);
    }
  }).trigger("resize");
}

// Set same-width for a batch of cached elements
//
// @return Void
function sameWidthSet($cachedObjects, widthType) {
  var max = -1;
  var h = 0;

  $cachedObjects.css({minWidth: 0});
  $cachedObjects.each(function() {
    h = widthType == "outerWidth" ? $(this).outerWidth() : $(this).width();
    max = h > max ? h : max;
  });

  $cachedObjects.css({minWidth: max});
}


// Target first link in the parent
//
function redirectToChildrenLink(e) {
  var $el = $(e.currentTarget);
  var $links = $el.find("a");

  if($links.length > 0) {
    window.location = $links.first().attr("href");
  }
}




// ---------------------------------------
// ---------------------------------------
// Resources center
// ---------------------------------------
// ---------------------------------------
var resources_center_timer,
    resources_center_based_url,
    resources_center_filter_content_height = 0;
function template_resources_center_init() {
  resources_center_based_url = $(".search-filters-content").data("based-url");
  $(".search-filters-content").on("change", "input", template_resources_center_handle_checkboxes);
  $(".search-filters-title").on("click", template_resources_center_handle_title_click);
}

// Handle checkboxes changes
//
function template_resources_center_handle_checkboxes(e) {
  $(".search-filters-title span").removeClass("hide");
  clearTimeout(resources_center_timer);

  // Reload page after a certain delay
  resources_center_timer = setTimeout(function() {
    var params = {};

    $(".search-filters-content input:checked").each(function() {
      var $input = $(this);

      if(params[$input.attr("name")]) {
        params[$input.attr("name")].push($input.val());
      }else{
        params[$input.attr("name")] = [$input.val()];
      }
    });

    window.location = resources_center_based_url+"?"+$.param(params);
  }, 1000);
}


// Handle filter click (mostly on mobile)
//
function template_resources_center_handle_title_click(e) {
  e.preventDefault();

  if($window.width() <= 1024) {
    var $parent = $(e.currentTarget).parents(".search-filters");
    var $content = $parent.find(".search-filters-content");

    // Detect initial height
    if(!$parent.hasClass("transition")) {
      $content.css("max-height", "9999px");
      window.resources_center_filter_content_height = $content.height();
      $content.css("max-height", "");

      // Prevent css animation glitch
      setTimeout(function() {
        $parent.addClass("transition");
        template_resources_center_handle_title_open($parent, $content);
      }, 450);
    }else{
      template_resources_center_handle_title_open($parent, $content);
    }
  }
}

function template_resources_center_handle_title_open($parent, $content) {
  $parent.toggleClass("open");

  if($parent.hasClass("open")) {
    $content.css("max-height", window.resources_center_filter_content_height+"px");
  }else{
    $content.css("max-height", "");
  }
}


// ---------------------------------------
// ---------------------------------------
// Accordions
// ---------------------------------------
// ---------------------------------------
function accordion_toggle(e) {
  e.preventDefault();
  var $el = $(e.currentTarget);
  var $parent = $el.parent();

  $el.toggleClass("active");
  $parent.toggleClass("active");
  $parent.find(".content").slideToggle(350);
}



// ---------------------------------------
// ---------------------------------------
// Header
// ---------------------------------------
// ---------------------------------------
function header_init() {
  $window.on("scroll", header_setSticky);

  // Secondary navigation
  if($(".inner-secondary-navigation").length > 0) {
    $window.on("scroll", header_setStickySecondaryNavigation)
           .on("scroll", header_setStickySecondaryNavigationActiveLink)
           .on("resize", header_setStickySecondaryNavigationTargets);

    $window.trigger("resize");
  }

  $window.trigger("scroll");

  // Mobile
  $(".main-menu .menu > .menu-item-has-children > a").on("click", header_mobileOpenSubmenu);
  $(".mobile-menu-wrapper-push").on("click", header_mobileMenuPush);
  $(".mobile-menu-wrapper-pull").on("click", header_mobileMenuPull);
}

function header_setSticky(e) {
  // Sticky on desktop only
  if($window.width() > 1024) {
    var header_height = $header.height();

    if(!$body.hasClass("sticky") && $window.scrollTop() > header_height) {
      // Set
      $body.addClass("sticky");
      $header.css("height", header_height+"px");
    }else if($body.hasClass("sticky") && $window.scrollTop() <= header_height){
      // Unset
      $body.removeClass("sticky");
      $header.css("height", "");
    }
  }
}

window.header_secondaryNavigationOffsetCached = 0;
function header_setStickySecondaryNavigation(e) {
  // Sticky on desktop only
  if($window.width() > 900) {
    var $secondary_nav = $(".inner-secondary-navigation");
    var $secondary_nav_wrapper = $(".secondary-navigation-wrapper");
    var secondary_nav_top = $secondary_nav.offset().top + $secondary_nav.height();

    if($window.width() <= 1024) {
      secondary_nav_top += 70;
    }

    var scroll_position = $window.scrollTop() + $("header .main-menu").height();

    if(!$body.hasClass("sticky-secondary-nav") && scroll_position > secondary_nav_top) {
      // Set
      $secondary_nav_wrapper.css("height", $secondary_nav_wrapper.height()+"px");
      $body.addClass("sticky-secondary-nav");
      window.header_secondaryNavigationOffsetCached = secondary_nav_top;
    }else if($body.hasClass("sticky-secondary-nav") && scroll_position <= window.header_secondaryNavigationOffsetCached){
      // Unset
      $body.removeClass("sticky-secondary-nav");
      $secondary_nav_wrapper.css("height", "");
    }
  }
}


function header_setStickySecondaryNavigationActiveLink(e) {
  // Sticky on desktop only
  if($window.width() > 1024 && window.secondaryNavigations_targets.length > 0) {
    var scroll_position = $window.scrollTop() + $("header .main-menu").height() + $(".inner-secondary-navigation").height() + 40;

    var last_target_selector = window.secondaryNavigations_targets[0][0];
    $.each(window.secondaryNavigations_targets, function(index, navigation_target) {
      if(scroll_position >= navigation_target[1]) {
        last_target_selector = navigation_target[0];
      }
    });

    $(".secondary-navigation a").removeClass("active");
    $(".secondary-navigation a[href='"+last_target_selector+"']").addClass("active");
  }
}

window.secondaryNavigations_targets = [];
function header_setStickySecondaryNavigationTargets() {
  window.secondaryNavigations_targets = [];
  $(".inner-secondary-navigation nav a").each(function() {
    var $el = $(this);
    var $target = $($el.attr("href"));

    if($target.length > 0) {
      window.secondaryNavigations_targets.push([$el.attr("href"), $target.offset().top]);
    }else{
      console.error("Undefined target", $el.attr("href"));
    }
  });

  window.secondaryNavigations_targets.sort(function(a, b){
    return a[1] - b[1];
  });
}


function header_mobileOpenSubmenu(e) {
  if($window.width() <= 1024) {
    var $el = $(e.currentTarget);

    $el.toggleClass("open");
    $el.parent().find("> .sub-menu").slideToggle();
    e.preventDefault();
  }
}


function header_mobileMenuPush(e) {
  $body.addClass("open-mobile");
  setTimeout(function() {
    $body.on("click", header_mobileMenuHandleBodyClose);
  }, 350);
  e.preventDefault();
}


function header_mobileMenuPull(e) {
  $body.removeClass("open-mobile");
  e.preventDefault();
}


function header_mobileMenuHandleBodyClose(e) {
  e.stopPropagation();
  var $target = $(e.target);

  if($target.parents(".mobile-menu-wrapper").length > 0 || $target.is(".mobile-menu-wrapper") || $target.is(".mobile-menu-wrapper-pull")) {
    // Do noting
  }else{
    $body.removeClass("open-mobile");
    $body.off("click", header_mobileMenuHandleBodyClose);
  }
}


// ---------------------------------------
// ---------------------------------------
// Newsletter
// ---------------------------------------
// ---------------------------------------
function newsletter_init() {
  $(".newsletter-form").on("submit", newsletter_handleSubmit);
}

function newsletter_handleSubmit(e) {
  e.preventDefault();
  var $form = $(e.currentTarget);
  var $input = $form.find("input");
  var email_value = $form.find("input").val();

  $input.removeClass("error");

  var email_domain = email_value.split("@");
  if(email_value.indexOf("@") != -1 && (email_domain[1] && email_domain[1].indexOf(".") != -1)) {
    // Valid & add to pardot
    $.ajax({
      type: "POST",
      url: $form.data("pardot"),
      data: {
        email: email_value,
        language: pardot_language(),
      },
      always: function(data) {
        // Do nothing
      },
    });

    // Confirmation
    $form.find("input, button").addClass("hide");
    $form.append("<p class='green mb0'><i class='fa fa-check'></i> "+$form.data("success")+"</p>");
  }else{
    // Error incorrect email adresse
    $input.addClass("error");
  }
}


// ---------------------------------------
// ---------------------------------------
// Form
// ---------------------------------------
// ---------------------------------------
function form_init() {
  // Thank you page tracking
  if($(".thank_you_page_id").length > 0) {
    setCookie("thank_you_page_id", $(".thank_you_page_id input").val(), 1);
  }

  //Location tracking
  if(getCookie("sv-formdata")) {
    var json = base64_to_json(getCookie("sv-formdata"));
    form_applyLocation(json);
  }else{
    var token = '57e51c326795823b1a5c7f1c6d77b7c974af919054f786437e7cc70ff59e763e';
    $.ajax({
      type: "GET",
      dataType: "json",
      //url: "http://api.ipstack.com/check?access_key="+token,
      url: "https://api.ipinfodb.com/v3/ip-city/?key="+token+"&format=json&callback=?",
      complete: function(data) {
        if(data.responseJSON && data.responseJSON.countryCode) {
          setCookie("sv-formdata", json_to_base64(data.responseJSON), 30);
          form_applyLocation(data.responseJSON);
        }
      },
    });
  }

  // File upload add class
  $(".ginput_container_fileupload").parent().addClass("gfield-file");
}

function form_applyLocation(geoip_json) {
  // Auto detect country
  if(geoip_json.countryCode) {
    form_autoSelect(geoip_json.countryCode);
  }

  // Auto detect state
  if(geoip_json.regionName) {
    form_autoSelect(geoip_json.regionName);
  }
}

function form_autoSelect(option_value) {
    var value = option_value;
    if($("option[value='"+option_value+"']").length<1)
    {
      value = option_value.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }
    var selectValue = $("option[value='"+value+"']");

    selectValue.prop('selected', true);

    if (selectValue.length > 0) {
      selectValue.parents('li').addClass('filled');
      selectValue.parents('select').trigger('change');
    }
}

function form_fields_init(field_wrapper_class, parent_wrapper_class) {
  var field_wrapper_class = typeof field_wrapper_class == "undefined" ? ".form" : field_wrapper_class;
  var parent_wrapper_class = typeof parent_wrapper_class == "undefined" ? ".form li" : parent_wrapper_class;

  var fields_selector = sprintf('%s input, %s textarea, %s select', field_wrapper_class, field_wrapper_class, field_wrapper_class);
  var $formControl = $(fields_selector);
  // Blur stats
  $formControl.blur(function() {
    $(parent_wrapper_class).removeClass('focus');
  });

  // Focus state
  $formControl.focus(function() {
    $(this).closest(parent_wrapper_class).addClass('focus');
  });

  /// Input Kepress Filled  Focus
  $formControl.not("select").keyup(function() {
    if($(this).val() && $(this).val().length > 0){
      $(this).closest(parent_wrapper_class).addClass('filled');
    }else{
      $(this).closest(parent_wrapper_class).removeClass('filled');
    }
  });

  $formControl.not("input").change(function() {
    if($(this).val() && $(this).val().length > 0){
      $(this).closest(parent_wrapper_class).addClass('filled');
    }else{
      $(this).closest(parent_wrapper_class).removeClass('filled');
    }
  });

  /// Input Check Filled Focus
  var values = {};
  var validate = $formControl.each(function() {
    var field_value = $(this).val() ? $(this).val() : "";
    if(field_value.length > 0){
      $(this).closest(parent_wrapper_class).addClass('filled');
    }else{
      $(this).closest(parent_wrapper_class).removeClass('filled');
    }
  });

      var $country = $(".country");
      $(".states_us, .states_au, .states_br, .states_cn, .states_ca, .states_ie, .states_it, .states_in, .states_mx").addClass("hide");
      $('.country select').on('change', form_handleCountryChange)
      .trigger("change");
}

function form_handleCountryChange(e) {
  $el = $(e.currentTarget);

    $(".states_us, .states_au, .states_br, .states_cn, .states_ca, .states_ie, .states_it, .states_in, .states_mx").addClass("hide");
    var el = $(e.currentTarget);
    var $states = el.val();
    var $states_select = $('.states_' + el.val().toLowerCase());
    $states_select.removeClass("hide");

    if($('.states_' + el.val().toLowerCase() + ' select option:first').val()!="")
    {
      $('.states_' + el.val().toLowerCase() + 'select').prepend("<option selected value=''></option>");
    }
    if(!$states_select.hasClass("geolocated"))
    {
       $states_select.val("");
    }
}

// ---------------------------------------
// ---------------------------------------
// Flexible content
// ---------------------------------------
// ---------------------------------------
function flexiblecontent_init() {
  //$(".loadMore").hide();
  // Simple text
  $(".custom-section.simple-text .row").each(function() {
    var $divs = $(this).find("> div");
    sameHeight($divs, 9999, 900, "outerHeight");
  });

  // Blocks
  $(".custom-section.blocks .row").each(function() {
    sameHeight($(this).find(".blocks-content"), 9999, 640, "height");
  });

  $(".custom-section.blocks .blocks-block-wrapper").on("click", redirectToChildrenLink);

  // Accordions
  $(".accordions-accordion h4").on("click", accordion_toggle);

  // Benefits
  $(".benefits-benefit.with-button").on("click", redirectToChildrenLink);
  $(".benefits").each(function() {
    sameHeight($(this).find(".benefits-benefit"), 9999, 900, "height");
  });

  // Dealer location
  $(".dealers").each(function() {
    sameHeight($(this).find(".location-box"), 9999, 0, "height");
  });

  // Events
  $(".tradeshows").each(function() {
    sameHeight($(this).find(".tradeshows-tradeshow-content"), 9999, 1024, "height");
    sameHeight($(this).find(".tradeshows-tradeshow-footer"), 9999, 1024, "height");
  });

  // CTA (With illustration)
  $(".cta-animated-truc").each(function() {
    sameHeight($(this).find(".row > div"), 9999, 900, "height");
  });
  $window.on("scroll", function() {
    $(".cta-animated-truc").each(function() {
      var window_bottom = window.innerHeight + $window.scrollTop();
      var $svg = $(this).find("svg");

      if($svg.position().top <= window_bottom) {
        $svg.addClass("start");
      }
    });
  });

  // CTA (Small)
  $(".cta-small").each(function() {
    sameHeight($(this).find(".row > div"), 9999, 1024, "height");
  });

  // Certifications
  $(".certifications").each(function() {
    sameHeight($(this).find(".gr-12"), 9999, 640, "height");
  });


  // Product introduction
  sameWidth($(".introduction-product .button"), 9999, 700, "width");
  $window.on("resize", productIntroduction_setImageWrapperHeight);
  $(".introduction-product-buttons-gallery, .introduction-product-body-gallery-more").on("click", productIntroduction_openGallery);


  // Slideshow
  slideshow_init();

  // Gallery
  // @todo: init code should be in an other function
  $('a.media').fancybox({
    padding: 0,
    margin: 0,
    nextEffect: 'fade',
    prevEffect: 'fade',
    helpers: {
        overlay: {
            locked: false
        }
    },
  });

  $(".see-more-gallery").on("click", gallery_handleOpenGallery);

  // Special equipment (show more)
  // @todo: init code should be in a specific function
  var $special_equipements_descriptions = $(".special_equipment .description-wrapper");
  var $buttons = $special_equipements_descriptions.find(".loadMore");
  var li_to_show = 10;

  $special_equipements_descriptions.each(function() {
    var $current = $(this);
    var $description_list_item = $current.find("li");
    if($description_list_item.length > li_to_show) {
      $current.find(".loadMore").removeClass("hide");

      $description_list_item.hide()
      $description_list_item.slice(0, li_to_show).show();
    }
  });

  $buttons.on("click", function() {
    var $el = $(this);
    var $parent = $el.parents(".description-wrapper");

    var showing = $parent.find("li").fadeIn();
    $el.addClass("hide");
  });
}

// Handle view gallery
//
function gallery_handleOpenGallery(e) {
  var $el = $(e.currentTarget);
  $el.parents(".global-gallery").find(".big-image").trigger("click");
}

// ---------------------------------------
// ---------------------------------------
// Product introduction
// ---------------------------------------
// ---------------------------------------
function productIntroduction_setImageWrapperHeight() {
  if($window.width() <= 1600 && $window.width() > 1024) {
    $(".custom-section.introduction-product .introduction-product-image").css("height", ($(".custom-section.introduction-product .introduction-product-image > a").outerHeight() + 10) + "px");
  }else{
    $(".custom-section.introduction-product .introduction-product-image").css("height", "");
  }
}


function productIntroduction_openGallery(e) {
  e.preventDefault();

  var $el = $(e.currentTarget);
  $el.parents(".introduction-product").find(".introduction-product-image > a").trigger("click");

}


// ---------------------------------------
// ---------------------------------------
// Slideshow
// ---------------------------------------
// ---------------------------------------
function slideshow_init() {
  window.$slideshows = $('.slideshow');

  if(window.$slideshows.length > 0) {
    window.$slideshows.slick({
      infinite: true,
      fade: true,
      slide: ".slideshow-slide",
      prevArrow: ".slideshow-prev",
      nextArrow: ".slideshow-next",
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 4000,
      draggable: false,
    });

    // Mobile set margin bottom based on highest content
    window.$slideshows.each(function() {
      sameHeight($(this).find(".slideshow-slide-content-inner"), 700, 0, "outerHeight", slideshow_setMarginBottom);
    });

    // On init and desktop only, set slideshow height to fix above screen
    if($window.width() > 700) {
      var slideshowHeight = window.innerHeight - $header.outerHeight();
      if(slideshowHeight >= 600) {
        $(".slideshow-slide, .slideshow-slide-content").css("height", slideshowHeight+"px");
      }
    }
  }
}

function slideshow_setMarginBottom(state) {
  if(state == "enable") {
    // Enable stats
    window.$slideshows.each(function() {
      var $slideshow = $(this);
      var content_height = $slideshow.find(".slideshow-slide-content-inner").outerHeight();

      // Margin bottom variables :
      //  **content_height**  Height of text container
      //  **+20px**           Extra margin at the bottom of the slideshow
      //  **-80px**           The content is inside the slideshow, so we remove this gap from margin bottom
      $slideshow.find(".slideshow-slide").css("marginBottom", (content_height+20-80));
    });
  }else{
    // Disable state
    window.$slideshows.find(".slideshow-slide").css("marginBottom", "");
  }
}



// ---------------------------------------
// ---------------------------------------
// Template form focus (Dynamic form)
// ---------------------------------------
// ---------------------------------------
function template_form_focus_init() {
  // Header & Quote summary
  $window.on("scroll", dform_setSticky);

  if($(".quote-summary:visible").length > 0) {
    $window.on("scroll", dform_summaryActiveLink)
           .on("resize", dform_summaryNavigationTargets);
  }

  $(".quote-summary-options").on("click", dform_handleSummaryOptionClick);

  var $quote_summary_small = $(".quote-summary-small:visible");
  if($quote_summary_small.length > 0) {
    $quote_summary_small.on("click", ".button", dform_handleQuoteSummarySmallClick);
    $window.on("scroll", dform_handleQuoteSummarySmallVisibility);
  }


  // Step 1.1
  dform_step10_init();
  $("[data-supervac-inner-step]").on("click", dform_step11_handleInnerStep);
  $("[data-supervac-truck-category]").on("click", dform_step11_handleTruckCategory);

  // Step 1.2
  $(".form-truck-only").each(function() {
    var $el = $(this);
    sameHeight($el.find(".form-truck-only-description, .form-truck-only-choices"), 9999, 1400, "outerHeight");
  });
  $(".form-truck-only-choices-radio").on("click", dform_step12_handleTrucSizeChoices);
  $(".form-truck-only").on("click", dform_step12_handleTruckConfirm);
  $(".form-truck-only .button").on("click", dform_step12_handleTruckButton);
  $(".return-step-1-1").on("click", dform_step12_handleReturnToStep);


  // Step 2
  dform_step20_init();
  $(".gform_body .gform_page:nth-child(2) input[type=checkbox]").on("change", dform_handleOptionsChange).trigger("change");
  $(".gform_body .gform_page:nth-child(2) .quote-summary .button").on("click", dform_step20_handleEquipmentConfirm);


  // Step 3
  dform_step30_init();
  $(".gform_body .gform_page:nth-child(3) input[type=checkbox]").on("change", dform_handleOptionsChange).trigger("change");
  $(".gform_body .gform_page:nth-child(3) .quote-summary .button").on("click", dform_step30_handleAccessoriesConfirm);


  // Step 4
  dform_step40_init();
  form_fields_init(".gform_body .gform_page:nth-child(4) .quote-summary", ".gform_body .gform_page:nth-child(4) .quote-summary > div");

  $(".gform_body .gform_page:nth-child(4) .edit-step").on("click", dform_step40_handleEditPreviousStep);

  dform_step40_fakeFieldSelect_init();
  $(".field-clone input, .field-clone textarea").on("keyup", dform_step40_handleFakeFieldText);
  $(".field-clone select").on("change", dform_step40_handleFakeFieldSelect);
  $(".add-comment").on("click", dform_step40_handleAddComment);

  $(".download-form, .share-form").on("click", dform_step40_handleLinkGeneration);
  $(".dform-share-popup-wrapper .button").on("click", dform_step40_handleLinkGenerationCopy);
  $(".dform-share-popup-wrapper .dform-share-popup-wrapper-close").on("click", dform_step40_handleLinkGenerationClose);
  new Clipboard('.dform-share-popup-wrapper .button');




  // Steps history
  var max_step = parseInt(getCookie("supervac-form-step"));
  max_step = isNaN(max_step) ? 1 : max_step;

  $(".gf_page_steps .gf_step").slice(0, max_step).addClass("gf_step_clickable");
  $(".gf_step_clickable").on("click", dform_handleStep);
  $(".gf_step_active .gf_step_number").attr("data-total-steps", $(".gf_step_number").length);


  // Step recover from URL
  if(getParameterByName("step") && getParameterByName("fid")) {
    // Check if at least step 1 is filled

    var is_first_step_filled = ($(".truck-category input").val() != "" && $(".truck-size input").val() != "" && $(".truck-series input").val() != "");
    var is_new_form_id = getCookie("supervac-loaded-from-query") != getParameterByName("fid");
    var is_different_step = $(".gf_step_active .gf_step_number").text() != getParameterByName("step");

    if(is_first_step_filled && is_new_form_id && is_different_step) {
      setCookie("supervac-loaded-from-query", getParameterByName("fid"), 1);
      dform_helperJumpTo(getParameterByName("step"));
    }
  }else{
    setCookie("supervac-loaded-from-query", "", 1);
  }
}

window.dform_cached_breakpoint = 0;
function dform_setSticky(e) {
  var $fake_header = $(".gf_page_steps");
  if(!$body.hasClass("dform-sticky")) {
    window.dform_cached_breakpoint = $(".gf_page_steps").offset().top + $(".gf_page_steps").outerHeight();
  }

  if(!$body.hasClass("dform-sticky") && $window.scrollTop() > window.dform_cached_breakpoint) {
    // Set
    $body.addClass("dform-sticky");

    if($(".quote-summary:visible").length > 0 && $window.width() > 900) {
      var padding_right = (dform_summarySetSticky("set") + 22.5) + "px";
      $fake_header.css("padding-right", padding_right);
      var after_style = "<style class='temp-tag'>.page-template-template-form-focus.dform-sticky .gform_wrapper .gf_page_steps:after { right: "+padding_right+"; }"
      $body.append(after_style);
    }
  }else if($body.hasClass("dform-sticky") && $window.scrollTop() <= window.dform_cached_breakpoint){
    // Unset
    $body.removeClass("dform-sticky");

    if($(".quote-summary:visible").length > 0 && $window.width() > 900) {
      dform_summarySetSticky("unset");
      $fake_header.css("padding-right", "");
      $(".temp-tag").remove();
    }
  }
}


// Simulate gravity form next page
//
function dform_helperJumpTo(page) {
  $("[id^=gform_target_page_number_]").val(page);
  $("form[id^=gform_]").trigger("submit", [true]);
}

// Simulate gravity form step back
//
function dform_handleStep(e) {
  var $el = $(e.currentTarget);

  dform_helperJumpTo($el.find(".gf_step_number").text());
}

// Summary set sticky
//
// @return Integer
function dform_summarySetSticky(state) {
  // Sticky on desktop only
  var $summary = $(".gform_page:visible .quote-summary");
  var summary_top = $summary.offset().top;

  // var scroll_position = $window.scrollTop() + $(".gf_page_steps").outerHeight() - 20;

  // if(!$body.hasClass("sticky-quote-summary") && scroll_position > summary_top) {
  if(state == "set") {
    // Set
    $summary.css("width", $summary.outerWidth() + "px");
    $summary.css("left", $summary.offset().left + "px");


    $body.addClass("sticky-quote-summary");
    window.dform_SummaryOffsetCached = summary_top;
  // }else if($body.hasClass("sticky-quote-summary") && scroll_position <= window.dform_SummaryOffsetCached){
  }else if(state == "unset"){
    // Unset
    $summary.css("width", "")
            .css("left", "");

    $body.removeClass("sticky-quote-summary");
  }

  // Return window padding-right to add to header
  return $window.width() - $summary.offset().left;
}



// Summary current position links
//
function dform_summaryActiveLink(e) {
  if(window.summary_targets.length > 0 && $window.width() > 900) {

    // Scroll position, at 40% of the screen
    var scroll_position = $window.scrollTop() + ($window.height() / 2.6);

    var last_target_selector = window.summary_targets[0][0];
    $.each(window.summary_targets, function(index, navigation_target) {
      if(scroll_position + 10 >= navigation_target[1]) {
        last_target_selector = navigation_target[0];
      }
    });

    $(".gform_page:visible .quote-summary .quote-summary-options").parent().removeClass("active");
    $(".gform_page:visible .quote-summary .quote-summary-options[data-target='"+last_target_selector+"']").parent().addClass("active");
  }
}

// Summary current position links
//
function dform_summaryNavigationTargets(e) {
  window.summary_targets = [];
  $(".gform_page:visible .quote-summary .quote-summary-options").each(function() {
    var $el = $(this);
    var $target = $($el.data("target"));

    window.summary_targets.push([$el.data("target"), $target.offset().top]);
  });

  window.summary_targets.sort(function(a, b){
    return a[1] - b[1];
  });
}


// Handle options change
//
function dform_handleOptionsChange(e) {
  var $el = $(e.currentTarget);

  // 1. Find total of checkbox boxes
  var options_quantity = $el.parents(".gfield_checkbox").find("input:checked").length;


  // 2. Find system option category
  var system_option_category_parent = $el.parents(".gfield").prev().attr("class").split(" ");
  var category_class = "";

  // find the class starting with sv-XXXXXXX
  $.each(system_option_category_parent, function(index, parent_class) {
    if(parent_class.indexOf("sv-") != -1) {
      category_class = "."+parent_class;
      return false;
    }
  });

  // 3. Insert quantity to the correct category
  if(category_class != "") {
    $(".quote-summary-options[data-target='"+category_class+"']").parent().find(".number").text(options_quantity);
  }

  // 4. Set quote-summary-small total
  dform_handleQuoteSummarySmallCountChange();
}

// Handle summarry categorie
//
function dform_handleSummaryOptionClick(e) {
  e.preventDefault();
  var $el = $(e.currentTarget);
  var $target = $($el.data("target"));

  if($target.length > 0) {
    scrollToTarget($($el.data("target")));
  }
}


// Scroll to quote summary
//
function dform_handleQuoteSummarySmallClick(e) {
  e.preventDefault();
  scrollToTarget($(".quote-summary:visible"), false);
}

// Hide quote summary small when we see the real quote summary
//
function dform_handleQuoteSummarySmallVisibility() {
  var scroll_bottom = $window.scrollTop() + $window.height();
  var $quote = $(".quote-summary:visible");

  if(scroll_bottom >= $quote.offset().top) {
    $body.addClass("remove-quote-summary-small");
  }else{
    $body.removeClass("remove-quote-summary-small");
  }
}


// Handle quote summary handle checkboxes changes
//
function dform_handleQuoteSummarySmallCountChange() {
  $(".gform_page:visible .quote-summary-small .number").text($(".gform_page:visible input:checked").length);
}


// Set max step from cookies
//
function dform_set_max_step(step) {
  var max_step = parseInt(getCookie("supervac-form-step"));

  if(isNaN(max_step) || max_step < step) {
    setCookie("supervac-form-step", step, 1);
  }
}


// 1.0 Handle step1 initialisation
//
function dform_step10_init() {
  if($(".gform_body .gform_page:nth-child(1)").is(":visible")) {
    // Cookie management
    // ----------
    var truck_category = $(".truck-category input").val();
    var truck_size = $(".truck-size input").val();
    var truck_series = $(".truck-series input").val();

    if(truck_category == "" || truck_size == "" || truck_series == "") {
      // If no field select, reset cookie
      setCookie("supervac-form-step", 1, 1);
    }else{
      dform_set_max_step(1);
    }


    // Inner step
    // ---------
    if(truck_category != "") {
      var $title = $("h3:contains('"+truck_category+"')");

      if($title.length > 0) {
        setTimeout(function() {
          $title.parents(".blocks-block-wrapper").trigger("click");

          if(truck_series != "" && truck_size != "") {
            var $inner_step_title = $(".form-truck-only h3:contains('"+truck_series+"')");
            $inner_step_title.parents(".form-truck-only").find("span:contains('"+truck_size+"')").trigger("click");
          }
        }, 100);
      }
    }
  }
}


// 1.1 Handle inner step without page reload aka when we chose a truck series
//
function dform_step11_handleInnerStep(e) {
  var $el = $(e.currentTarget);

  // Hide parent (.gfield) of the current element
  $el.parents(".gfield").addClass("hide");

  // Show inner step title
  var section_title = $el.find("h3").text();
  $(".title-selected-truck-category-wrapper").removeClass("hide");
  $(".title-selected-truck-category").text(section_title);

  // Targeted elements
  $($el.data("supervac-inner-step")).removeClass("hide");

  // Force truck-only sameheight
  $window.trigger("resize");
}


// 1.1 Handle truck category selection
//
function dform_step11_handleTruckCategory(e) {
  var $el = $(e.currentTarget);
  $(".truck-category input").val($el.data("supervac-truck-category"));
}


// 1.2 Handle truck size choices
//
function dform_step12_handleTrucSizeChoices(e) {
  // Toggle active state
  $(".form-truck-only-choices-radio").removeClass("active");
  $(".form-truck-only").removeClass("active");
  $(".form-truck-only .button").addClass("button-disabled");

  var $el = $(e.currentTarget);
  $el.addClass("active");

  var $parent = $el.parents(".form-truck-only");
  $parent.addClass("active");
  $parent.find(".button").removeClass("button-disabled");

  // Truck size
  var truck_size = $.trim($el.text());
  $(".truck-size input").val(truck_size);

  // Series name
  var truck_series = $.trim($el.parents(".form-truck-only").find("h3").text());
  $(".truck-series input").val(truck_series);
}


// 1.2 Handle truck next choice
//
function dform_step12_handleTruckConfirm(e) {
  e.preventDefault();
}


// 1.2 Handle truck button go to next step
//
function dform_step12_handleTruckButton(e) {
  e.preventDefault();

  var $el = $(e.currentTarget);
  var $parent = $el.parents(".form-truck-only");

  if($(".truck-series input").val() != "" && $(".truck-size input").val() != "" && $parent.hasClass("active")){
    var $el = $(e.currentTarget);
    dform_helperJumpTo($el.data("jump-to"));
  }
}

// 1.2 Return to truck category
//
function dform_step12_handleReturnToStep(e) {
  e.preventDefault();

  // Reset fields values
  $(".truck-category input").val("");
  $(".truck-size input").val("");
  $(".truck-series input").val("");


  // Toggle classes
  $(".title-selected-truck-category-wrapper").addClass("hide");
  $(".form-truck-only").parents("li").addClass("hide");
  $(".step-1-1-wrapper").removeClass("hide");
  $window.trigger("resize");
}


// 2.0 Handle step2 initialisation
//
function dform_step20_init() {
  if($(".gform_body .gform_page:nth-child(2)").is(":visible")) {
    // Cookie management
    // ----------
    dform_set_max_step(2);

    // Main title
    // -------
    var $step2_dynamic_title = $(".step-2-dynamic-title h2.has-h1");

    // Truck series
    if($(".truck-series input").val() != "") {
      $step2_dynamic_title.find("span").text($(".truck-series input").val()+ " equipment");
    }

    // Truck wheels
    if($(".truck-size input").val() != "") {
      $step2_dynamic_title.append("<small>("+$(".truck-size input").val().replace(" ", "&nbsp;")+")</small>");
    }

    // Truck picture in summary
    // -------
    if($(".truck-series input").val() != "") {
      var $thumbnail = $(".form-truck-only h3:contains('"+$(".truck-series input").val()+"')").parents(".form-truck-only").find("b");
      if($thumbnail.length > 0) {
        $(".quote-summary-thumbnail").css("background-image", $thumbnail.css("background-image"));
      }
    }
  }
}


// 2.0 Handle equipement confirm / button click
//
function dform_step20_handleEquipmentConfirm(e) {
  e.preventDefault();
  var $el = $(e.currentTarget);

  dform_helperJumpTo($el.data("jump-to"));
}


// 3.0 Handle step3 initialisation
//
function dform_step30_init() {
  if($(".gform_body .gform_page:nth-child(3)").is(":visible")) {
    // Cookie management
    // ----------
    dform_set_max_step(3);


    // Truck picture in summary
    // -------
    if($(".truck-series input").val() != "") {
      var $thumbnail = $(".form-truck-only h3:contains('"+$(".truck-series input").val()+"')").parents(".form-truck-only").find("b");
      if($thumbnail.length > 0) {
        $(".quote-summary-thumbnail").css("background-image", $thumbnail.css("background-image"));
      }
    }
  }
}


// 3.0 Handle form submit on step 3
//
function dform_step30_handleAccessoriesConfirm(e) {
  e.preventDefault();
  var $el = $(e.currentTarget);

  dform_helperJumpTo($el.data("jump-to"));
}

// 4.0 Handle step4 initialisation
//
function dform_step40_init() {
  if($(".gform_body .gform_page:nth-child(4)").is(":visible")) {
    // Cookie management
    // ----------
    dform_set_max_step(4);


    // Section title
    // -------
    $(".form-final-summary h2 span").text($(".truck-series input").val());

    if($(".truck-size input").val() != "") {
      // Truck wheels
      $(".form-final-summary h2").append(" ("+$(".truck-size input").val().replace(" ", "&nbsp;")+")");
    }


    // Summary selected options
    // ---------
    $(".gform_body .gform_page:nth-child(4) .form-options-included").each(function() {
      var $el = $(this);

      // Get data
      var $checked_inputs = $($el.data("target")).next().find("input:checked");
      var options_count = $checked_inputs.length;
      var html_list = "";

      if(options_count > 0) {
        var html_list = "<ul>";

        $checked_inputs.each(function() {
          html_list += sprintf("<li>%s</li>", $(this).val());
        });

        html_list += "</ul>";
      }

      // Set data
      var $title = $el.find("h4");
      if(options_count > 0) {
        $title.find("span").text(options_count);

        $el.append(html_list);
      }else{
        $title.html($title.html().replace(":", ""));
        $el.addClass("empty");
      }
    });


    // Truck picture in summary
    // -------
    if($(".truck-series input").val() != "") {
      var $thumbnail = $(".form-truck-only h3:contains('"+$(".truck-series input").val()+"')").parents(".form-truck-only").find("b");
      if($thumbnail.length > 0) {
        $(".form-final-summary-thumbnail").css("background-image", $thumbnail.css("background-image")).removeClass("contains");
        $(".dform-share-popup-thumbnail").css("background-image", $thumbnail.css("background-image")).removeClass("contains");

        if($thumbnail.hasClass("contains")) {
          $(".form-final-summary-thumbnail").addClass("contains");
          $(".dform-share-popup-thumbnail").addClass("contains");
        }
      }
    }
  }
}


// 4.0 Edit previous steps
//
function dform_step40_handleEditPreviousStep(e) {
  e.preventDefault();
  dform_helperJumpTo($(e.currentTarget).data("jump-to"));
}

// 4.0 Fake field select initialisation
//
function dform_step40_fakeFieldSelect_init() {
  // @debug mode
  // $(".gform_body .gform_page:nth-child(4) .gfield.hide").removeClass("hide");
  // $(".gform_body .gform_page:nth-child(4) .gfield.hide-no-js").removeClass("hide-no-js");

  // Generate text <input> (hidden field => fake field)
  // ---------
  $(".field-clone input, .field-clone textarea").each(function() {
    var $el = $(this);
    var $target = $($el.data("field-target"));

    // Required field?
    $orignal_target = $target.parents(".gfield");
    if($orignal_target.hasClass("gfield_contains_required")) {
      $el.addClass("required");
      $el.parent().find("label").append(" *");
    }

    // Errors on field?
    if($orignal_target.hasClass("gfield_error")) {
      $el.parent().addClass("error");
    }

    $el.val($target.val());
  });

  $(".field-clone input").trigger("keyup");


  // Countries / Provinces
  // ---------
  dform_step40_setCountryStatesTarget();

  $(".field-clone select").each(function() {
    var $el = $(this);
    var $target = $($el.data("field-target"));

    // Required field?
    $orignal_target = $target.parents(".gfield");
    if($orignal_target.hasClass("gfield_contains_required")) {
      $el.addClass("required");
      $el.parent().find("label").append(" *");
    }

    // Errors on field?
    if($orignal_target.hasClass("gfield_error")) {
      $el.parent().addClass("error");
    }

    $el.html($target.html());
  });

  $(".field-clone select").trigger("change");

  // Comment
  // ------
  var $comment = $("#iComment");
  if($comment.val() != "") {
    setTimeout(function() {
      $(".add-comment").trigger("click");
      $comment.trigger("keyup");
    }, 100);
  }
}


// 4.0 Fake field transfert data to orignal field
//
function dform_step40_handleFakeFieldText(e) {
  var $el = $(e.currentTarget);

  $($el.data("field-target")).val($el.val());
}

// 4.0 Fake field transfert data to orignal selected
//
function dform_step40_handleFakeFieldSelect(e) {
  var $el = $(e.currentTarget);

  $($el.data("field-target")).val($el.val());

  // Country handle
  if($el.is("#iCountry")) {
    dform_step40_setCountryStatesTarget(true);
  }
}

// 4.0 Fake field transfert data to orignal selected
//
function dform_step40_setCountryStatesTarget(resetProvinceValues) {
  var $country = $("#iCountry");
  var $province = $("#iProvince");

  if($country.val() == "US") {
    var data_value = $province.data("field-target").replace(/(states-ca|states-us|states )/, "states-us ");
  }else{
    // CA States
    var data_value = $province.data("field-target").replace(/(states-ca|states-us|states )/, "states-ca ");
  }

  $province.data("field-target", data_value);


  if(resetProvinceValues) {
    var $target = $($province.data("field-target"));
    $province.html($target.html());
    $province.val("");
    $province.trigger("change");
  }
}


// 4.0 Handle add comment link
//
function dform_step40_handleAddComment(e) {
  e.preventDefault();
  var $el = $(e.currentTarget);

  $el.addClass("hide");
  $el.next().removeClass("hide");
}


// 4.0 Handle link to share our download
//
function dform_step40_handleLinkGeneration(e) {
  e.preventDefault();
  var $el = $(e.currentTarget);

  // 1. Generate the query string
  // if($el.is("download-form")) {
  //  // @todo: Should we include name, first, last name, etc.
  // }

  var queryString = {
    "truck-cat": $(".truck-category input").val(),
    "truck-size": $(".truck-size input").val(),
    "truck-series": $(".truck-series input").val(),
    "opt-water": dform_step40_generateCheckboxesValues($(".sv-water-system").next().find("input:checked")),
    "opt-vacuum": dform_step40_generateCheckboxesValues($(".sv-vacuum-system").next().find("input:checked")),
    "opt-toolbox": dform_step40_generateCheckboxesValues($(".sv-tool-box-aluminium").next().find("input:checked")),
    "opt-electrical": dform_step40_generateCheckboxesValues($(".sv-electrical-feature").next().find("input:checked")),
    "opt-hose": dform_step40_generateCheckboxesValues($(".sv-hose-reel").next().find("input:checked")),
    "opt-debris": dform_step40_generateCheckboxesValues($(".sv-debris-body").next().find("input:checked")),
    "opt-boom": dform_step40_generateCheckboxesValues($(".sv-boom-system").next().find("input:checked")),
    "truck-accessories": dform_step40_generateCheckboxesValues($(".sv-accessories").next().find("input:checked")),
    "step": 4,
    "fid": Math.floor(Math.random()*100000),
  };

  var current_url = window.location.href.split("?")[0]; // Remove query string
  current_url = current_url.split("#")[0]; // Remove anchor

  var share_link = current_url+"?"+$.param(queryString);

  $(".dform-share-popup-wrapper input").val(share_link);

  // 2. Show or hide social sharing
  if($el.is(".download-form")) {
    $(".dform-share-popup-share").addClass("hide");
  }else{
    $(".dform-share-popup-share").removeClass("hide");

    // Generate - Social Links
    var facebook_url = $(".dform-share-popup-share .facebook").data("template").replace("[LINK]", share_link);
    $(".dform-share-popup-share .facebook").attr("href", facebook_url);

    var linkedin_url = $(".dform-share-popup-share .linkedin").data("template").replace("[LINK]", share_link)
                                                                               .replace("[TITLE]", encodeURI($("title").text()));
    $(".dform-share-popup-share .linkedin").attr("href", linkedin_url);

    var mailto_url = $(".dform-share-popup-share .email").data("template").replace("[LINK]", share_link)
                                                                          .replace("[TITLE]", encodeURI($("title").text()));
    $(".dform-share-popup-share .email").attr("href", mailto_url);
  }
  $(".dform-share-popup-wrapper h2 span").text($el.text());

  // 3. Show popup
  $(".dform-share-popup").toggleClass("show");
}

// Close the popup
//
function dform_step40_handleLinkGenerationClose(e) {
  e.preventDefault();
  $(".dform-share-popup").removeClass("show");
}

// 4.0 Generate an array from checked checboxes
//
function dform_step40_generateCheckboxesValues($checkboxes) {
  var values = [];

  $checkboxes.each(function() {
    values.push($(this).val());
  });

  return values;
}

// 4.0 Handle Button copy action
function dform_step40_handleLinkGenerationCopy(e) {
  e.preventDefault();

  $(".dform-share-popup-input-wrapper").addClass("copied");
  setTimeout(function() {
    $(".dform-share-popup-input-wrapper").removeClass("copied");
  }, 2000);
}

// Modal PopUp for docuentation download
function downloadModal(state) {
  var linkDocument = $(event.currentTarget).attr("href");
  var modalForm = $('.custom-form');
  var modalWrapper = $('.modal-backdrop');

  $('.validation_error, .validation_message').remove();
  modalForm.toggle();
  if(state.data.param == 'open')
  {
    var docInput = modalForm.find('.document input');
    docInput.val(linkDocument);
    if(!modalWrapper.hasClass('in'))
    {
      if ($('.pardot-iframe').length > 0){
        var currentUrl = $('.pardot-iframe iframe').attr('src');
        var url = new URL(currentUrl);
        url.searchParams.set("fichier", linkDocument); // setting your param
        var newUrl = url.href;
        $('.pardot-iframe iframe').attr( 'src', newUrl );
      }

      $('body').append('<div class="modal-backdrop fade in"></div>');
      $('.modal-backdrop').bind('click', { param: 'close'}, downloadModal);
    }
  }
  else
  {
    modalWrapper.remove();
  }
}

//Preselect the "Requested Equipment" field or set the cookie
function form_equipment_cookie_init(e){
  if ($('.equipment_select').length > 0) {
    var referer_request = getCookie('supervac_equipment_request');
    if (referer_request != null) {
      $('.equipment_select select').val(referer_request);
      $('.equipment_select').addClass('filled');
    }
  }

  if (typeof requested_equipment !== 'undefined') {
    setCookie('supervac_equipment_request', requested_equipment, 1);
  }
  else{
    if ($('.equipment_select').length == 0){
      setCookie('supervac_equipment_request', null, 1);
    }
  }
}

// When the pin is clicked, show/hide her content
//
$mapPin = $('.map-pin');
$mapContent = $mapPin.find('.content');
$mapPin.hover(showPinContent);

$mapPin.on('click', function(e){
  e.preventDefault();
});

function showPinContent(e) {
  $mapContent.hide();
  var aimedContent = $(e.currentTarget);
  if(aimedContent.hasClass('show'))
  {
    aimedContent.find('.content').hide();
    aimedContent.removeClass('show');
  }
  else
  {
    $('.map-pin').removeClass('show');
    aimedContent.find('.content').show();
    aimedContent.addClass('show');
  }
}

$mapPin.on('mouseleave', function() {
  $mapContent.hide();
  $('.map-pin').removeClass('show');
});